
import {distinctUntilChanged} from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { INode } from '../Configuration/INode';
import { LoggerService } from '../logger-service/logger.service';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConfigSearchService } from './config-search/config-search.service';

@Component({
    selector: 'wbm-config-breadcrumb',
    templateUrl: './config-breadcrumb.component.html',
    styleUrls: ['../../assets/theme/css/ConfigBreadcrumb.css']
})
export class ConfigBreadcrumbComponent implements OnInit, OnDestroy {
    @Input() public rootNode1: INode;
    public nodeList: Array<INode>;

    private subscriptions: Array<Subscription> = [];

    constructor(private _logger: LoggerService, private _oxeModel: OxeModelService, private _translate: TranslateService, public _searchService: ConfigSearchService) { }

    ngOnInit() {
        this.subscriptions.push(this._oxeModel.selectedNodeObserver.pipe(
            distinctUntilChanged())
            .subscribe(node => {
                console.log("BreadCrumb ngOnInit()");
                if (node) {
                    this.nodeList = node.getNodePath().slice(2).filter((n) => !n.isOneInstance || n.isClassNode);
                }
            }));
    }

    ngOnDestroy() {
        //release global subscriptions
        this.removeGlobalSubscriptions();
    }

    private removeGlobalSubscriptions() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }

    public nodeSelected(item: INode) {
        this._logger.debug('ConfigBreadcrumbComponent', item.name + 'selected');

        if (item.isLocal) {
            this._oxeModel.selectNode(item);
        } else {
            // Retrieve data only for object nodes or "Oneinstance" class nodes
            if (item.isClassNode && !item.isOneInstance) {
                this._oxeModel.selectNode(item);
            } else {
                this._oxeModel.retrieveData(item)
                    .subscribe(() => {
                        this._oxeModel.selectNode(item);
                    });
            }
        }
        this._oxeModel.helpNode(item);
        this._searchService.showSearch = false;
    }

    public getUnsavedName(item: INode): string {
        if (item.isObjectNode && item.isLocal) {
            let translatedUnsavedLabel: string;
            this._translate.get('unsaved-node').subscribe((resp) => translatedUnsavedLabel = resp);
            let colon: string = (item.name && item.name !== '') ? ': ' : '';
            return translatedUnsavedLabel + '#' + item.localIdx + colon;
        } else {
            return '';
        }
    }
}
